const state = {
  isLoading: false,
  list: [],
  isInvoiceLoading: false,
  invoicelist: [],
  comments: [],
  commentLoading: false,
  isUploading: false,
  isEmptyPaginate: false,
  hasEmpty: false,
  isRejected: false,
  uploadResponse: {},
  filter: {},
  tempCharges: {},
  indentDetails: [],
  dedicatedTruckMaster: null,
  invoiceDetails: [],
  totalSystemCharges: 0,
  totalTransporterCharges: 0,
  transporterTotalFreightCharge: 0,
  freightBillDetails: null,
  freightBillCategories: {},
  totalIndentCount: 0,
  isDedicatedTruck: null,
  depotWiseDetails: {},
  selectedPaymentsList: [],
  paymentMovements: [],
  proformaInvoiceNumber: '',
  invoiceApprovalSettings: {},
  invoiceLevelApprovalSettings: {},
  selectedLegalEntity: null,
  isShipperChargesFeatureEnabled: false,
};

export default state;
